// stepwise.component.ts
import { ChangeDetectorRef, Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ApiResponseComponent } from '../../api-response/api-response.component';
import { RestService } from 'src/app/Services/rest.service';
import { ImageSnippetDialogComponent } from '../../image-snippet-dialog/image-snippet-dialog.component';
import { TemplateResultDialogComponent } from '../../template-result-dialog/template-result-dialog.component';
import { forkJoin } from 'rxjs';
import { NotifyService } from 'src/app/Services/notify.service';
import { getBrand } from 'src/environments/brand';

@Component({
  selector: 'ze-stepwise',
  templateUrl: './stepwise.component.html',
  styleUrls: ['./stepwise.component.scss']
})
export class StepwiseComponent {
  brand = getBrand();

  @Input() statusModel: any;
  @Input() expandStep: number;
  @Input() reportStatus: any;
  @Input() reportId: any;
  @Input() browser: any;
  @Input() iteration: any;
  @Input() isDb2: boolean = false;
  stepsData: any[] = [];
  loopsData: any[] = [];

  constructor(private dialog: MatDialog, private restService: RestService, private cdr: ChangeDetectorRef, private notifys: NotifyService) { }

  private readonly templateMatchCommandNames = [
    'validate response template',
    'verify response matches template',
  ];

  isTemplateMatchCommand(ctv: any): boolean {
    const name = ctv && ctv.command && ctv.command.name;
    return this.templateMatchCommandNames.indexOf(name) !== -1;
  }

  isRealWarning(ctv: any): boolean {
    if (!ctv || !ctv.warningMessage) {
      return false;
    }
    if (this.isTemplateMatchCommand(ctv) && ctv.warningMessage.indexOf('All ') === 0) {
      return false;
    }
    return true;
  }

  inlineMessage(rawMessage: string, ctv: any): string {
    if (!rawMessage) {
      return rawMessage;
    }
    if (!this.isTemplateMatchCommand(ctv)) {
      return rawMessage;
    }
    const newlineIndex = rawMessage.indexOf('\n');
    return newlineIndex === -1 ? rawMessage : rawMessage.substring(0, newlineIndex);
  }

  openTemplateResultDialog(ctv: any): void {
    const message = ctv.failureMessage || ctv.warningMessage || '';
    this.dialog.open(TemplateResultDialogComponent, {
      width: '640px',
      maxWidth: '95vw',
      height: '480px',
      maxHeight: '85vh',
      autoFocus: false,
      data: { message },
    });
  }

  expandAllDetails() {
    const detailsElements = document.querySelectorAll('details');
    detailsElements.forEach((detailsElement: HTMLDetailsElement) => {
      detailsElement.open = true;
    });
    const loopElements = document.querySelectorAll('[name*="loopList."]');
    loopElements.forEach((loopElement: HTMLElement) => {
      loopElement.style.display = "block";
    });
  }

  collapseAllDetails() {
    const detailsElements = document.querySelectorAll('details');
    detailsElements.forEach((detailsElement: HTMLDetailsElement) => {
      detailsElement.open = false;
    });
    const loopElements = document.querySelectorAll('[name*="loopList."]');
    loopElements.forEach((loopElement: HTMLElement) => {
      loopElement.style.display = "none";
    });
  }

  ngOnInit() {
    this.updateStepsData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.updateStepsData();
  }

  updateStepsData() {
    let stepOrder = 1;
    let commandStepOrder = 1;
    let tempStepsData = [];
    this.statusModel.structure.forEach(struct => {
      if (struct._type === "feature") {
        if (struct.structure != undefined
          && struct.structure.length > 0) {
          struct.structure.forEach(featStruct => {
            if (featStruct._type === "scenario") {
              if (featStruct.structure != undefined
                && featStruct.structure.length > 0) {
                featStruct.structure.forEach(scenarioStruct => {
                  scenarioStruct["order"] = stepOrder++;
                  scenarioStruct["suiteName"] = this.statusModel.name;
                  scenarioStruct["stepName"] = struct.name + ' > ' + featStruct.name + ' > ' + scenarioStruct.name;
                  scenarioStruct.commandStepsData.forEach(commandStep => {
                    commandStep["order"] = commandStepOrder++;
                  });
                  tempStepsData.push(scenarioStruct);
                });
              }
            } else if (featStruct._type === "step") {
              featStruct["order"] = stepOrder++;
              featStruct["suiteName"] = this.statusModel.name;
              featStruct["stepName"] = struct.name + ' > ' + featStruct.name;
              featStruct.commandStepsData.forEach(commandStep => {
                commandStep["order"] = commandStepOrder++;
              });
              tempStepsData.push(featStruct);
            }
          });
        }
      } else if (struct._type === "scenario") {
        if (struct.structure != undefined
          && struct.structure.length > 0) {
          struct.structure.forEach(scenarioStruct => {
            scenarioStruct["order"] = stepOrder++;
            scenarioStruct["suiteName"] = this.statusModel.name;
            scenarioStruct["stepName"] = struct.name + ' > ' + scenarioStruct.name;
            scenarioStruct.commandStepsData.forEach(commandStep => {
              commandStep["order"] = commandStepOrder++;
            });
            tempStepsData.push(scenarioStruct);
          });
        }
      } else if (struct._type === "step") {
        struct["order"] = stepOrder++;
        struct["suiteName"] = this.statusModel.name;
        struct["stepName"] = struct.name;
        struct.commandStepsData.forEach(commandStep => {
          commandStep["order"] = commandStepOrder++;
        });
        tempStepsData.push(struct);
      }
    });
    this.stepsData = tempStepsData;
  }

  isObject(node: any): boolean {
    return typeof node === 'object' && !Array.isArray(node);
  }

  isArray(node: any): boolean {
    return Array.isArray(node);
  }

  isLoopRequired(arrayNode: any, i: number): boolean {
    console.log("Array size: ",arrayNode.length);
    if (arrayNode.length > 1 && arrayNode[i][0]['status'] == '' 
      && i > 0) {
        return false
    }
    return true;
  }

  loopFilter(node: any) {
    node = node.filter(item => {
      return !(
        (item[0].status === "" && item[item.length - 1].status === "")
      );
    });
    this.loopsData = node;
    console.log(this.loopsData)
  }

  expandDetails(loopIndex: any) {
    const loopList = document.getElementsByName("loopList" + loopIndex)
    Array.from(loopList).forEach(element => {
      element.style.display = "block";
    });
  }

  collapseDetails(loopIndex: any) {
    const loopList = document.getElementsByName("loopList" + loopIndex)
    Array.from(loopList).forEach(element => {
      element.style.display = "none";
    });
  }

  // Fixed method to open API response dialog for value field
  openApiResponseForValue(ctv: any): void {
    console.log("Opening API response for value:", ctv.value);
    
    if (ctv.command.type === 'API' && ctv.value) {
      try {
        // Parse the JSON string if it's a string, otherwise use as-is
        let apiResponseData;
        if (typeof ctv.value === 'string') {
          apiResponseData = JSON.parse(ctv.value);
        } else {
          apiResponseData = ctv.value;
        }

        console.log("Parsed API response data:", apiResponseData);

        const dialogRef = this.dialog.open(ApiResponseComponent, {
          // minHeight: '600px',
          // minWidth: '800px',
          // width: '90%',
          // maxWidth: '1200px',
          // height: '80%',
          // maxHeight: '80vh',
          data: {
            command: ctv.command,
            status: apiResponseData.status || '200 OK',
            time: apiResponseData.time || '0ms',
            headers: apiResponseData.headers || {},
            cookies: apiResponseData.cookies || [],
            body: apiResponseData.body || '',
            size: apiResponseData.size || '0 bytes',
            apiObjectId: (ctv.target && ctv.target._id) ? ctv.target._id : null,
            apiObjectName: (ctv.target && ctv.target.name) ? ctv.target.name : null
          }
        });

        dialogRef.afterClosed().subscribe(result => {
          console.log('API Response dialog was closed');
        });
      } catch (error) {
        console.error('Error parsing API response data:', error);
        console.log('Raw value:', ctv.value);
        
        // Fallback: try to display the raw value
        const dialogRef = this.dialog.open(ApiResponseComponent, {
          // width: '90%',
          // maxWidth: '1200px',
          // height: '80%',
          // maxHeight: '800px',
          data: {
            command: ctv.command,
            status: '200 OK',
            time: '0ms',
            headers: {},
            cookies: [],
            body: ctv.value, 
            size: '0 bytes'
          }
        });

        dialogRef.afterClosed().subscribe(result => {
          console.log('API Response dialog was closed');
        });
      }
    } else {
      console.log('Not an API command or no value present');
    }
  }

  hasApiResponse(ctv: any): boolean {
    return ctv.command.type === 'API' && ctv.value;
  }

  hasApiValue(ctv: any): boolean {
    return ctv.command.type === 'API' && ctv.value;
  }

  isValue1Secure(ctv: any): boolean {
    const flag: any = (ctv as any).value1SecureMode;
    // Default to NOT secure when undefined/null so plain value shows by default
    if (flag === undefined || flag === null) return false;
    // Treat true, 'true', 1, '1' as secure
    return flag === true || flag === 'true' || flag === 1 || flag === '1';
  }

  hasImageSnippet(ctv: any): boolean {
  return !!ctv.imageSnippetPath;
}

openImageSnippet(ctv: any): void {
  const basePath = ctv.imageSnippetPath;

  const paths = [
    basePath + '/captured_image',
    basePath + '/search_region'
  ];

  forkJoin(
    paths.map(p => this.restService.get('getBase64Img', p))
  ).subscribe({
    next: ([capturedUrl, searchUrl]: string[]) => {
      this.dialog.open(ImageSnippetDialogComponent, {
        width: '90%',
        maxWidth: '1200px',
        data: {
          captured: capturedUrl.trim(),
          search: searchUrl.trim(),
        }
      });
    },
    error: (err) => {
      console.error('Failed to fetch image snippets', err);
    }
  });
}

getWebobjectApproval(ctv: any, target: 'target' | 'target2'): any {
  return target === 'target2' ? ctv.target2WebobjectApproval : ctv.targetWebobjectApproval;
}

isApprovalPending(ctv: any, target: 'target' | 'target2'): boolean {
  const approval = this.getWebobjectApproval(ctv, target);
  const finishedStatuses = ['Completed', 'Failed', 'Execution Failed', 'Aborted'];
  return !!approval && approval.status === 'pending' && finishedStatuses.includes(this.reportStatus);
}

decideWebobjectApproval(ctv: any, target: 'target' | 'target2', decision: 'approve' | 'reject'): void {
  const approval = this.getWebobjectApproval(ctv, target);
  if (!approval || !approval.approval_path || approval.decisionInProgress) {
    if (approval && !approval.approval_path) {
      this.notifys.onError('Approval Failed', 'No approval path found for this step');
    }
    return;
  }

  approval.decisionInProgress = true;
  this.cdr.detectChanges();

  const payload = {
    executionId: (this.reportId && this.reportId.$oid) ? this.reportId.$oid : this.reportId,
    dbName: this.isDb2 ? 'db2' : 'db1',
    browser: this.browser,
    iteration: this.iteration,
    approvalPath: approval.approval_path,
    target: target,
    secondaryId: approval.secondary_id,
    decision: decision,
    approvedBy: localStorage.getItem('username')
  };

  this.restService.put('updateWebobjectApproval', payload).subscribe({
    next: (res: any) => {
      const updatedApproval = res && res.data ? res.data : null;
      approval.status = updatedApproval && updatedApproval.status ? updatedApproval.status : (decision === 'approve' ? 'approved' : 'rejected');
      approval.approved_by = updatedApproval && updatedApproval.approved_by ? updatedApproval.approved_by : payload.approvedBy;
      approval.approved_at = updatedApproval && updatedApproval.approved_at ? updatedApproval.approved_at : Date.now();
      approval.decisionInProgress = false;
      this.cdr.detectChanges();
    },
    error: (err) => {
      this.notifys.notifyApiError('Approval Failed', err, 'Failed to update approval decision');
      approval.decisionInProgress = false;
      this.cdr.detectChanges();
    }
  });
}
}